import { Button } from '@/components/ui/button';
import { useFeaturesCategory } from '@/providers/features-category.provider';
import { navLinks } from '@/utils/data/nav-links';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export function MobileMenu({ isActive, onClose }: { isActive: boolean; onClose: () => void }) {
  const [mounted, setMounted] = useState(false);
  const router = useRouter();
  const { goToFacturationElectronique, setActiveCategory } = useFeaturesCategory();

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return createPortal(
    <>
      {/* Overlay */}
      <div
        style={{ zIndex: 100 }}
        className={[
          'fixed inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-300',
          isActive ? 'pointer-events-auto opacity-100' : 'pointer-events-none opacity-0',
        ].join(' ')}
        onClick={onClose}
      />

      {/* Drawer */}
      <nav
        className={clsx(
          'fixed top-0 right-0 z-200 flex h-screen w-[80vw] max-w-sm flex-col bg-white shadow-2xl transition-transform duration-400',
          isActive ? 'translate-x-0' : 'translate-x-full',
        )}
      >
        <ul className="flex flex-1 flex-col gap-1 px-8 pt-28 pb-6">
          {navLinks.map((link, i) => (
            <li key={i} className="block overflow-hidden">
              <Button
                href={link.href}
                target={link.target}
                variant="transparent"
                className={clsx(
                  'flex items-center border-b border-gray-100 py-4 text-base font-medium text-gray-800 transition-all duration-400',
                  isActive ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0',
                )}
                style={{
                  transitionDelay: `${i * 50}ms`,
                }}
                isAnchor
                onClick={(event) => {
                  if (link.href !== '/#facturation-electronique') {
                    onClose();
                    return;
                  }

                  event.preventDefault();
                  onClose();

                  if (router.pathname !== '/') {
                    setActiveCategory('facturation');
                    void router.push(link.href, undefined, { scroll: false });
                    return;
                  }

                  goToFacturationElectronique();
                }}
              >
                {link.label}
              </Button>
            </li>
          ))}
        </ul>

        <div className="flex flex-col gap-3 px-8 pb-10">
          <Button href="tel:330184257027" variant="transparent">
            01 84 25 70 27
          </Button>
          <Button href="/contact/" variant="fill" onClick={onClose}>
            Demandez une démo
          </Button>
        </div>
      </nav>
    </>,
    document.body,
  );
}
